module.exports = __webpack_public_path__ + "static/feature-window-01-77c4b6a910ddde5635f8c7a6536c36f0.png";